import { render, staticRenderFns } from "./addPage.vue?vue&type=template&id=b1cf5c18&scoped=true&"
import script from "./addPage.vue?vue&type=script&lang=js&"
export * from "./addPage.vue?vue&type=script&lang=js&"
import style0 from "./addPage.vue?vue&type=style&index=0&id=b1cf5c18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1cf5c18",
  null
  
)

export default component.exports